// Get Performance Links
export const GET_PERFORMANCE_LINKS_REQUEST = 'GET_PERFORMANCE_LINKS_REQUEST';
export const GET_PERFORMANCE_LINKS_DONE = 'GET_PERFORMANCE_LINKS_DONE';
export const GET_PERFORMANCE_LINKS_FAILED = 'GET_PERFORMANCE_LINKS_FAILED';

// Operations
export const UPDATE_USER_PERFORMANCE_LINKS = 'UPDATE_USER_PERFORMANCE_LINKS';
export const TOGGLE_PERFORMANCE_LINKS = 'TOGGLE_PERFORMANCE_LINKS';
export const TOGGLE_ALL_PERFORMANCE_LINKS = 'TOGGLE_ALL_PERFORMANCE_LINKS';
export const SET_PERFORMANCE_LINKS_USERS_TO_FILTER = 'SET_PERFORMANCE_LINKS_USERS_TO_FILTER';
export const SET_PERFORMANCE_LINKS_FILTER = 'SET_PERFORMANCE_LINKS_FILTER';
export const SET_PERFORMANCE_LINKS_ALL_FILTERS = 'SET_PERFORMANCE_LINKS_ALL_FILTERS';
export const CLEAR_PERFORMANCE_LINKS_FILTERS = 'CLEAR_PERFORMANCE_LINKS_FILTERS';
export const PERFORMANCE_LINKS_SET_PAGE = 'PERFORMANCE_LINKS_SET_PAGE';
export const PERFORMANCE_LINKS_ERRORS_RESET = 'PERFORMANCE_LINKS_ERRORS_RESET';
export const PERFORMANCE_LINKS_RESET = 'PERFORMANCE_LINKS_RESET';